import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from './BannerAnimation.module.scss';
import BannerAnimationContent from './BannerAnimationContent';

interface BannerAnimationProps {
  children: ReactNode;
}

export default function BannerAnimation({ children }: BannerAnimationProps) {
  return (
    <span className={styles.wrapper}>
      <span className={clsx(styles.content, 'text-bold')}>{children}</span>
      <BannerAnimationContent />
    </span>
  );
}
